import { Component, DestroyRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { Exclusion } from '@shared/models/exclusion.model';
import { Formation } from '@shared/models/formation.model';
import { FormationsGroups } from '@shared/models/formationsGroups.model';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { Motif } from '@shared/models/motif.model';
import { Reason } from '@shared/models/reason.model';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { MotifService } from '@shared/services/motif.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { UtilisService } from '@shared/services/utilis.service';
import moment from 'moment';
import { StorageService } from 'src/app/core/services/storage.service';
import { ExclusionService } from 'src/app/shared/services/exclusion.service';
import { HOSPITAL_END_TIME, HOSPITAL_START_TIME } from '../../const/globals.const';
import { Hospital } from '../../models/hospital.model';
import { Profile } from '../../models/profile.model';
import { ReasonMap } from '../../models/reasonMap.model';
import { Specialty } from '../../models/specialty.model';
import { User } from '../../models/user.model';
import { ErrorService } from '../../services/error.service';
import { ProfileService } from '../../services/profile.service';
import { SpecialtyService } from '../../services/specialty.service';
import { UserService } from '../../services/user.service';
import { getHoursAndMinutes, toPascalCase } from '../../utils/cross-functions';
import { VacationService } from '../../services/vacation.service';
import { WishesService } from '../../services/wishes.service';
import { HoursInputComponent } from '../hours-input/hours-input.component';
import { MY_FORMATS } from './data-format-vacation.const';
import posthog from 'posthog-js';

@Component({
  selector: 'app-vacation-hrsuite-dialog',
  templateUrl: './add-vacation-hrsuite-popup.component.html',
  styleUrls: ['./add-vacation-hrsuite-popup.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'fr' },
  ],
  standalone: false,
})
export class addVacationHrsuitePopupComponent implements OnInit {
  private instanceId: string;

  @ViewChild('startTime', { static: false })
  public startTime: HoursInputComponent = new HoursInputComponent();

  @ViewChild('endTime', { static: false })
  public endTime: HoursInputComponent = new HoursInputComponent();

  public toPascalCase = toPascalCase;

  public isSending: boolean = false;

  public day: any;

  public period: string | undefined;

  public currentUser: User;

  public formGroup: FormGroup | undefined;

  public allProfiles: Profile[] | undefined;

  public profiles: Profile[] = [];

  public loadingProfiles: boolean = false;

  public isNurses: boolean = false;

  public typeInf: string = 'Aide Opératoire';

  public typeAnesth: string = '';

  public specialties: any[] | undefined;

  public anesthSpecialties: any[] | undefined;

  public chosenSpecialty: string = 'Orthopédie membre inférieur';

  public chosenSpecialties: string[] = [];

  public specialtyProfiles: any[] | undefined;

  public specialtyProfiles2: any[] | undefined;

  public showSeniority: boolean = false;

  public haveSeniority: boolean = true;

  public resultProfiles: any[] = [];

  public resultProfiles2: any[] = [];

  public originalResultProfiles2: any[] = [];

  public resultProfiles3: any[] = [];

  public chosenSeniorities: string[] = ['Senior', 'Junior', 'Interne'];

  public chosenResedencies: string[] = ['Vacataire', 'Titulaire'];

  public chosenPositions: any = ['IBODE', 'IDE'];

  public showRole: boolean = true;

  public today: Date | null = null;

  public isSpinning: boolean = false;

  public isDisabled: boolean = false;

  public vacation: any;

  public roles: any[] = [];

  public nursesPosition: any[] = [];

  public motifs: Motif[] = [];

  public loadingInit: boolean = true;

  public vacationModesOptions: string[] = [];

  public vacationModes: any[] = [];

  public actifVacationModeOption: string = '';

  public actifVacationMode: string = '';

  public residencies: {
    label: string;
    value: string;
    isChecked: boolean;
    isDisabled: boolean;
  }[] = [];

  public seniorities: {
    label: string;
    value: string;
    isChecked: boolean;
    isDisabled: boolean;
  }[] = [];

  public typeInfOptions = [
    {
      label: 'Tous les rôles',
      value: 'undefined',
    },
  ];

  public typeAnesthOptions = [
    {
      label: 'Tous les rôles',
      value: 'undefined',
    },
  ];

  public availabilities = [
    {
      label: 'Présence',
      value: 'AVAILABLE',
    },
    {
      label: 'Récupération',
      value: 'ABSENT',
    },
  ];

  public availability: string = 'AVAILABLE';

  public isMultiHospitals: boolean = false;

  public hospitals: any[] = [];

  public selectedHospitalsId: any;

  private principalHospitalId: string | undefined;

  public accessOptions: AccessOptions | undefined;

  public selectedReasonMap: ReasonMap | null = null;

  public formationsGroupOfPosition: FormationsGroups | undefined;

  public reasonsMaps: ReasonMap[] = [];

  public isNight: boolean = false;

  public campaign: any = null;

  public hospital: Hospital | undefined;

  public conditionalWidth: string = '570px';

  public filteredReasonsMaps: ReasonMap[] = [];

  public isTimeCodeDisabled: boolean = true;

  public hospitalNames: HospitalNames;

  public selectedMotif: Motif | null = null;

  public availableOutOfRoomProfiles: (Profile & { isOutOfRoom: boolean })[] = [];

  public isBasicService: boolean;

  public exclusions: Exclusion[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly wishesService: WishesService,
    private readonly formBuilder: FormBuilder,
    private readonly profileService: ProfileService,
    private readonly userService: UserService,
    private readonly vacationService: VacationService,
    private readonly errorService: ErrorService,
    private readonly specialtyService: SpecialtyService,
    private readonly storageService: StorageService,
    private readonly dialogRef: MatDialogRef<addVacationHrsuitePopupComponent>,
    private readonly router: Router,
    private readonly utilisService: UtilisService,
    private readonly motifService: MotifService,
    private readonly exclusionService: ExclusionService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.hospitalNames = this.userService.getHospitalNames();
    this.isBasicService = this.userService.isBasicService();
    this.typeAnesth = this.hospitalNames.blocName;

    if (this.data.specialty && this.data.role) {
      this.vacationModesOptions = [
        `Cibler ${this.hospitalNames.vacationsNameGenreMasculin ? 'le' : 'la'} ${this.hospitalNames.vacationsName.toLowerCase()}`,
      ];

      this.vacationModes = [
        {
          label: `Cibler ${this.hospitalNames.vacationsNameGenreMasculin ? 'le' : 'la'} ${this.hospitalNames.vacationsName.toLowerCase()}`,
          value: 'targetVacation',
        },
      ];
    } else {
      this.vacationModesOptions = [
        `Diffuser ${this.hospitalNames.vacationsNameGenreMasculin ? 'un' : 'une'} ${this.hospitalNames.vacationsName.toLowerCase()}`,
        `Cibler ${this.hospitalNames.vacationsNameGenreMasculin ? 'le' : 'la'} ${this.hospitalNames.vacationsName.toLowerCase()}`,
      ];

      this.vacationModes = [
        {
          label: `Diffuser ${this.hospitalNames.vacationsNameGenreMasculin ? 'un' : 'une'} ${this.hospitalNames.vacationsName.toLowerCase()}`,
          value: 'nonTargetVacation',
        },
        {
          label: `Cibler ${this.hospitalNames.vacationsNameGenreMasculin ? 'le' : 'la'} ${this.hospitalNames.vacationsName.toLowerCase()}`,
          value: 'targetVacation',
        },
      ];
    }
    this.actifVacationModeOption = this.vacationModesOptions[0];
    this.actifVacationMode = this.vacationModes[0].value;
    if (this.data.vacation) {
      this.vacation = this.data.vacation.vacation ?? this.data.vacation;
    }

    this.currentUser = this.userService.getCurrentUser();
    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    this.day = this.data.date ? new Date(this.data.date) : nextDay;
    this.getConditionalWidth();
  }

  public get needs() {
    return Array.from({ length: 5 }, (_v: any, k: any) => k + 1);
  }

  public get targeted() {
    return this.formGroup?.controls?.['targeted']?.value;
  }

  public get competenceFilter() {
    return this.formGroup?.controls?.['competenceFilter']?.value;
  }

  /**
   * Check if any profile has been selected
   */
  public get isAnyProfileChecked() {
    return this.resultProfiles2.some((profile: any) => profile.checked);
  }

  public get position() {
    return this.formGroup?.controls?.['position']?.value;
  }

  async ngOnInit() {
    if (this.data.topAccessOptions) {
      this.accessOptions = this.data.topAccessOptions;
    } else {
      this.accessOptions = this.userService.getAccessOptionsOfPage(this.router.url) ?? {};
    }

    if (this.isNursePage()) {
      this.isNurses = true;
      this.data.position = this.data.position?.filter((pos: any) => pos.name != 'IADE' && pos.name != 'Iade');
    }
    if (this.accessOptions?.seniority) {
      this.seniorities = [];
      this.accessOptions?.seniority.forEach((seniority: string) => {
        this.seniorities.push({
          label: seniority,
          value: seniority,
          isChecked: false,
          isDisabled: false,
        });
      });
    }

    if (this.accessOptions?.seniority?.length === 1 && this.accessOptions?.seniority[0] === 'Interne') {
      this.seniorities = [
        {
          label: 'Interne',
          value: 'Interne',
          isChecked: false,
          isDisabled: false,
        },
      ];
    }

    if (this.accessOptions?.residencyInPopUp) {
      this.residencies = [];
      this.accessOptions?.residencyInPopUp.forEach((residency: string) => {
        this.residencies.push({
          label: residency,
          value: residency,
          isChecked: false,
          isDisabled: false,
        });
      });
    }

    if (this.isNursePage()) {
      this.isNurses = true;
      this.data.position = this.data.position;
    }
    this.getExclusions();
    await this.getMotifs();
    this.isMultiHospitals = this.userService.isCurrentUserHasMultipleHospitalsSelected();
    this.selectedHospitalsId = this.userService.getSelectedHospitals();
    this.currentUser = this.storageService.getUser();
    this.principalHospitalId = this.storageService.getData('principalHospitalId');
    this.selectedHospitalsId.forEach((hospitalId: any) => {
      const hospital = this.currentUser.profile?.hospitals?.find(
        (hospital: any) => String(hospital._id) == String(hospitalId)
      );
      if (hospitalId === this.principalHospitalId) {
        this.hospitals.unshift({
          name: hospital?.name,
          _id: hospital?._id,
          startTime: hospital?.startTime,
          endTime: hospital?.endTime,
          displayName: this.userService.resolveHospitalName(String(hospital?._id)),
        });
      } else {
        this.hospitals.push({
          name: hospital?.name,
          displayName: this.userService.resolveHospitalName(String(hospital?._id)),
          _id: hospital?._id,
          startTime: hospital?.startTime,
          endTime: hospital?.endTime,
        });
      }
    });
    this.hospital = this.hospitals.find(
      (hospital: Hospital) =>
        String(hospital._id) == String(this.vacation ? this.vacation.hospital._id : this.hospitals[0]._id)
    );
    this.chosenResedencies =
      this.vacation?.residency === 'Titulaire et Vacataire'
        ? ['Vacataire', 'Titulaire']
        : this.vacation?.residency === 'Vacataire'
          ? ['Vacataire']
          : ['Titulaire'];
    if (this.data?.specialties) {
      this.data.specialties?.forEach((spec: any) =>
        spec.distribution?.forEach((dis: any) => this.chosenSpecialties.push(dis.specialty))
      );
    }
    if (this.accessOptions?.isAnesthMode || (window.location.href.endsWith('campaigns') && !this.data.isNurse)) {
      this.typeAnesth = this.vacation?.informations?.type ?? this.hospitalNames.blocName;
      this.typeAnesth = this.data.type ? this.data.type : this.hospitalNames.blocName;
      await this.getAnesthSpecialties(this.hospitals[0]?._id);
      this.chosenPositions = this.vacation?.position || this.data.position[0];
      this.chosenSpecialty =
        this.chosenSpecialties.length >= 1
          ? this.chosenSpecialties[0]
          : this.vacation?.informations?.specialty && this.vacation?.informations?.specialty?._id
            ? this.vacation?.informations?.specialty?._id
            : 'undefined';

      this.typeInf = this.vacation?.informations?.roleName;
      this.typeInfOptions = [
        {
          label: this.typeInf,
          value: this.typeInf,
        },
      ];
      this.makeAnestForm(this.chosenPositions, this.chosenResedencies);
      this.getProfilesBySpecialty('anesth', this.hospitals[0]?._id);
    } else {
      this.chosenPositions =
        this.vacation?.formations?.map(
          (formation: any) => this.data.position?.find((pos: any) => pos._id === formation)?.name
        ) ?? [];
      await this.getSpecialties(this.hospitals[0]?._id).then((specialties: any) => {
        this.specialties = specialties;
      });
      this.chosenSpecialty =
        this.chosenSpecialties.length >= 1
          ? this.chosenSpecialties[0]
          : this.vacation?.informations?.specialty && this.vacation?.informations?.specialty?._id
            ? this.vacation?.informations?.specialty?._id
            : 'undefined';
      this.typeInf = this.vacation?.informations?.roleName;
      this.typeInfOptions = [
        {
          label: this.typeInf,
          value: this.typeInf,
        },
      ];
      this.makeForm(this.chosenPositions, this.chosenResedencies);
      this.getProfilesBySpecialty('nurse', this.hospitals[0]?._id);
    }
    this.formationsGroupOfPosition = await this.userService.getFormationsGroupOfProfile({
      position: this.formGroup?.get('position')?.value,
    });
    this.showSeniority = this.formationsGroupOfPosition?.isUsingSeniorities ?? false;

    this.today = new Date();
    if (this.data.date) {
      this.formGroup?.get('day')?.setValue(this.data.date);
    } else {
      this.formGroup?.get('day')?.setValue(this.today);
    }
    if (!this.vacation) {
      await this.getAvailableAndOutOfRoomProfiles();
      await this.getProfiles();
    }

    this.onValueChanges();

    if (this.data.specialty && this.data.specialty._id) {
      this.formGroup?.get('competence')?.setValue(this.data.specialty._id);
    }
    if (this.data.role && this.data.role._id) {
      this.formGroup?.get('typeInf')?.setValue(this.data.role._id);
    }

    if (this.vacation && this.vacation.individuals && this.vacation.individuals.length > 0) {
      this.setCompetenceFilter(true);
      this.toggleClick(
        `Cibler ${this.hospitalNames.vacationsNameGenreMasculin ? 'le' : 'la'} ${this.hospitalNames.vacationsName.toLowerCase()}`
      );
    }

    this.createNursesPosition();
    if (this.isNurses) {
      this.isNursesNeeded(this.chosenSpecialty);
    } else {
      this.isAnesthNeeded(this.chosenSpecialty);
    }
    this.getIsTimeCodeDisabled();

    if (this.data.reasonsMaps && this.data.reasonsMaps.length > 0) {
      this.reasonsMaps = this.data.reasonsMaps;

      this.filteredReasonsMaps = this.reasonsMaps;
      if (this.data.preselectedReasonMap) {
        if (this.nursesPosition.length > 0 && this.nursesPosition[0].value) {
          this.formGroup?.get('position')?.setValue(this.nursesPosition.map((e: any) => e.value));
        }
        this.formGroup?.get('residency')?.setValue(['Titulaire', 'Vacataire']);
        this.availabilities = this.availabilities.slice(0, 1);
        this.selectedReasonMap =
          this.reasonsMaps.find((rm: ReasonMap) => rm._id === this.data.preselectedReasonMap._id) ?? null;

        const startTime = getHoursAndMinutes(this.selectedReasonMap?.morningStartTime);
        const endTime = getHoursAndMinutes(this.selectedReasonMap?.afternoonEndTime);
        this.setStartTime(startTime);
        this.setEndTime(endTime);
      }

      this.filterReasonsMapsByDisponibility();
      this.filterReasonsMapsByPosts();
      this.filterReasonsMapsByWeekDay();
      this.filterReasonsMapsByService();
      this.filterReasonsMapsByResidencies();
      this.filterReasonsMapsBySeniorities();

      this.changePreselectedReasonMap(
        this.data.reasonsMaps.find((reasonMap: ReasonMap) => reasonMap._id === this.vacation?.reasonMap),
        false
      );
    }
    this.loadingInit = false;
  }

  changePreselectedReasonMap(selectedReasonMap: ReasonMap | null, autoSelectHoursFromReasonMap: boolean = true) {
    if (!selectedReasonMap) {
      this.selectedReasonMap = null;
      if (this.availability === 'ABSENT') {
        this.isDisabled = true;
      }
      return;
    }
    const exclude_profiles: string[] = [];
    for (const profile of this.originalResultProfiles2) {
      const exclusion = this.exclusions.find(
        (e: Exclusion) =>
          String(e.profile) === String(profile._id) &&
          e.reasonMap &&
          typeof e.reasonMap === 'object' &&
          String(e.reasonMap?._id) === String(selectedReasonMap._id) &&
          e.days?.includes(this.day.getDay())
      );
      if (exclusion) {
        exclude_profiles.push(String(profile._id));
      }
      const checked = this.resultProfiles2.find(
        (e: any) => String(e._id) === String(profile._id) && e.checked === true
      );
      profile.checked = checked ? true : false;
    }
    this.resultProfiles2 = this.originalResultProfiles2.filter((e: any) => !exclude_profiles.includes(e._id));
    if (autoSelectHoursFromReasonMap && selectedReasonMap.morningStartTime && selectedReasonMap.afternoonEndTime) {
      this.setStartTime(getHoursAndMinutes(selectedReasonMap.morningStartTime));
      this.setEndTime(getHoursAndMinutes(selectedReasonMap.afternoonEndTime));
      if (this.startTime) {
        this.startTime.setTime(getHoursAndMinutes(selectedReasonMap.morningStartTime));
      }
      if (this.endTime) {
        this.endTime.setTime(getHoursAndMinutes(selectedReasonMap.afternoonEndTime));
      }
    }
    this.selectedReasonMap = selectedReasonMap;
    this.isDisabled = false;
  }

  getMotifs() {
    return new Promise<void>((resolve: any, reject: any) => {
      this.subscriptionManager
        .createRequest(this.motifService.getAllMotifs('VACATIONS'), 'getAllMotifs', this.instanceId)
        .subscribe({
          next: (res: any) => {
            this.motifs = res;
            const motif = this.motifs.find((motif: Motif) => motif._id === this.vacation?.motif);
            this.selectedMotif = motif ?? null;
            resolve();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject();
          },
        });
    });
  }

  getExclusions() {
    this.subscriptionManager
      .createRequest(this.exclusionService.getAllExclusions(), 'getAllExclusions', this.instanceId)
      .subscribe({
        next: async (res: any) => {
          this.exclusions = res;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  onChangeSelectedMotif(motif: Motif) {
    this.selectedMotif = motif;
  }

  getStartTime(): string {
    return this.formGroup?.get('startTime')?.value;
  }

  getEndTime(): string {
    return this.formGroup?.get('endTime')?.value;
  }

  getIsTimeCodeDisabled() {
    if (this.formGroup) {
      if (this.formGroup.get('position')?.value?.length > 0 && this.formGroup.get('residency')?.value?.length > 0) {
        this.isTimeCodeDisabled =
          typeof this.formGroup.get('position')?.value === 'string' &&
          this.formGroup.get('position')?.value === 'Anesthésiste' &&
          this.formGroup.get('seniority')?.value.length === 0;
      } else {
        this.isTimeCodeDisabled = true;
      }
    }
  }

  setStartTime(time: string): void {
    if (this.selectedReasonMap && !this.selectedReasonMap.mutableHours) {
      this.changePreselectedReasonMap(null);
    }
    this.formGroup?.get('startTime')?.patchValue(time);
  }

  setEndTime(time: string): void {
    if (this.selectedReasonMap && !this.selectedReasonMap.mutableHours) {
      this.changePreselectedReasonMap(null);
    }
    this.formGroup?.get('endTime')?.patchValue(time);
  }

  shortenHours(data: any) {
    return data ? data.toString().substring(11, 16) : '--:--';
  }

  filterReasonsMapsByDisponibility() {
    const availability = this.formGroup?.get('availability')?.value !== 'ABSENT' ? 'ABSENT' : 'AVAILABLE';
    this.reasonsMaps = this.data.reasonsMaps.filter((reasonMap: ReasonMap) => {
      const reason = this.data.reasons.find((r: ReasonMap) => r._id === reasonMap.reason);
      if (reason?.availability === 'AVAILABLE' || (reason?.availability === 'ABSENT' && reasonMap.recuperation)) {
        return reason.availability !== availability;
      }
      return false;
    });
  }

  filterReasonsMapsByPosts() {
    const chosenPositions: string[] = Array.isArray(this.chosenPositions)
      ? this.chosenPositions
      : [this.chosenPositions?.name ?? this.chosenPositions];
    if (chosenPositions.length === 0) {
      if (this.selectedReasonMap) {
        return;
      } else {
        this.filteredReasonsMaps = [];
        return;
      }
    }
    this.filteredReasonsMaps = this.reasonsMaps.filter(
      (reasonMap: ReasonMap) =>
        reasonMap?.positions &&
        chosenPositions.every((position: string) =>
          reasonMap.positions?.includes(position === 'IADE' ? 'Iade' : position)
        )
    );

    if (this.data.preselectedReasonMap) {
      this.selectedReasonMap =
        this.filteredReasonsMaps.find((rm: ReasonMap) => rm._id === this.data.preselectedReasonMap._id) ?? null;
    }
  }

  filterReasonsMapsByWeekDay() {
    if (!this.formGroup || !this.formGroup.get('day')?.value) {
      return;
    }

    const chosenDay = new Date(this.formGroup!.get('day')!.value).getDay();

    this.filteredReasonsMaps = this.filteredReasonsMaps.filter((reasonMap: ReasonMap) => {
      return !Array.isArray(reasonMap.days) || reasonMap.days.length === 0 || reasonMap.days.includes(chosenDay);
    });
  }

  filterReasonsMapsByService() {
    if (this.isMultiHospitals) {
      this.filteredReasonsMaps = this.filteredReasonsMaps.filter(
        (reasonMap: ReasonMap) => reasonMap.hospital === this.formGroup?.get('hospitals')?.value?._id
      );
    } else {
      this.filteredReasonsMaps = this.filteredReasonsMaps.filter(
        (reasonMap: ReasonMap) => reasonMap.hospital === this.hospitals[0]._id
      );
    }
  }

  filterReasonsMapsByResidencies() {
    this.filteredReasonsMaps = this.filteredReasonsMaps.filter((reasonMap: ReasonMap) => {
      const reason = this.data.reasons.find((r: Reason) => r._id === reasonMap.reason);
      return (
        reason &&
        this.chosenResedencies.length > 0 &&
        this.chosenResedencies.every((residency: string) => reason.residencies.includes(residency))
      );
    });
  }

  filterReasonsMapsBySeniorities() {
    const chosenPositions: string[] = Array.isArray(this.chosenPositions)
      ? this.chosenPositions
      : [this.chosenPositions?.name ?? this.chosenPositions];
    if (
      this.isNurses !== true &&
      chosenPositions &&
      chosenPositions.length === 1 &&
      chosenPositions[0] === 'Anesthésiste'
    ) {
      this.filteredReasonsMaps = this.filteredReasonsMaps.filter((reasonMap: ReasonMap) => {
        const reason = this.data.reasons.find((r: Reason) => r._id === reasonMap.reason);
        return (
          reason &&
          this.chosenSeniorities.length > 0 &&
          this.chosenSeniorities.every((seniority: string) => reason.seniority.includes(seniority))
        );
      });
    }
  }

  onSelectOpen() {
    this.filterReasonsMapsByDisponibility();
    this.filterReasonsMapsByPosts();
    this.filterReasonsMapsByWeekDay();
    this.filterReasonsMapsByService();
    this.filterReasonsMapsByResidencies();
    this.filterReasonsMapsBySeniorities();
  }

  getConditionalWidth(): string {
    if (this.actifVacationMode === 'nonTargetVacation') {
      return '570px';
    }
    return '1400px';
  }

  async onDateChange() {
    if (!this.vacation) {
      await this.getAvailableAndOutOfRoomProfiles();
      await this.getProfiles();
      if (this.availability === 'AVAILABLE') {
        if (!this.accessOptions?.isAnesthMode) {
          this.getProfilesBySpecialty('nurse', this.hospitals[0]?._id);
        } else {
          this.getProfilesBySpecialty('anesth', this.hospitals[0]?._id);
        }
      }
    }
  }

  onAvailabilityChange(event: any) {
    if (this.data.preselectedReasonMap) {
      this.selectedReasonMap =
        this.filteredReasonsMaps.find(
          (rm: ReasonMap) =>
            rm._id === this.data.preselectedReasonMap._id || rm.code === this.data.preselectedReasonMap.code
        ) || null;
    } else {
      this.selectedReasonMap = null;
    }
    this.availability = event;
    this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
    if (event === 'ABSENT') {
      this.formGroup?.get('competence')?.setValue('undefined');
      this.formGroup?.get('typeInf')?.setValue('undefined');
      this.formGroup?.get('typeAnesth')?.setValue('undefined');
      this.isDisabled = true;
    } else {
      if (this.isAnesthesistePage()) {
        this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeAnesth);
      } else {
        this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeInf);
      }
      this.isDisabled = false;
    }
  }

  async onChangeService() {
    if (this.accessOptions?.isAnesthMode || (window.location.href.endsWith('campaigns') && !this.data.isNurse)) {
      this.getAnesthSpecialties(this.formGroup?.get('hospitals')?.value?._id);
      this.getProfilesBySpecialty('anesth', this.formGroup?.get('hospitals')?.value?._id);
    } else {
      this.getSpecialties(this.formGroup?.get('hospitals')?.value?._id).then((specialties: any) => {
        this.specialties = specialties;
      });
      this.getProfilesBySpecialty('nurse', this.formGroup?.get('hospitals')?.value?._id);
    }
    this.hospital = this.hospitals.find(
      (hospital: Hospital) => String(hospital._id) == String(this.formGroup?.get('hospitals')?.value?._id)
    );
    this.createNursesPosition();
    this.formGroup?.get('position')?.setValue([]);
    this.formGroup?.get('residency')?.setValue([]);
    this.chosenPositions = [];
    if (!this.vacation) {
      await this.getAvailableAndOutOfRoomProfiles();
      await this.getProfiles();
    }
    this.selectedReasonMap = null;
  }

  toggleClick(event: any) {
    const vacationMode = this.vacationModes.find((el: any) => el.label === event);
    this.actifVacationMode = vacationMode?.value ?? '';
    if (this.actifVacationMode === 'nonTargetVacation') {
      this.formGroup?.get('competenceFilter')?.patchValue(false);
      this.formGroup?.get('targeted')?.patchValue(false);
    } else {
      this.formGroup?.get('competenceFilter')?.patchValue(true);
      this.formGroup?.get('targeted')?.patchValue(true);
    }
    this.getConditionalWidth();
    this.actifVacationModeOption = vacationMode?.label ?? '';
  }

  isAnesthesistePage() {
    return (
      this.accessOptions?.isAnesthMode ||
      (window.location.href.endsWith('campaigns') && !this.data.isNurse) ||
      (window.location.href.endsWith('recap') && !this.data.isNurse)
    );
  }

  isNursePage() {
    return (
      !this.accessOptions?.isAnesthMode ||
      (window.location.href.endsWith('campaigns') && this.data.isNurse) ||
      (window.location.href.endsWith('recap') && this.data.isNurse)
    );
  }

  close(): void {
    this.dialogRef.close(false);
  }

  async formatPosition(): Promise<string> {
    const positions = (
      await this.userService.getAccessOptionsPositionsByPositions(this.accessOptions?.positions || this.data.position)
    ).map((formation: Formation) => formation.name);
    return positions.join(',');
  }

  /**
   * Return only the profiles that match the selected formations
   * @param profiles
   * @returns
   */
  filterNurses(profiles: any[]) {
    return this.filterOnResidency(profiles);
  }

  /**
   * Filter profiles based on residency
   * @param profiles the profiles to filter
   * @returns the filtered profiles
   */
  filterOnResidency(profiles: any[]) {
    let selectedResidencies = this.formGroup?.controls['residency']?.value;

    if (!Array.isArray(selectedResidencies)) {
      selectedResidencies = [selectedResidencies];
    }

    return profiles.filter((profile: any) => selectedResidencies.includes(profile.residency));
  }

  async getProfiles() {
    this.loadingProfiles = true;
    const vacationDate = this.formGroup?.get('day')?.value;
    const vacationFormattedDate = moment(vacationDate).format('YYYY-MM-DD');

    this.subscriptionManager
      .createRequest(
        this.profileService.getReachableProfiles(vacationFormattedDate, await this.formatPosition()),
        'getReachableProfiles',
        this.instanceId
      )
      .subscribe({
        next: (res: any) => {
          this.allProfiles = JSON.parse(JSON.stringify(res));

          if (this.isNursePage()) {
            this.profiles = this.filterNurses(this.allProfiles ?? []);
          } else {
            this.profiles = this.filterOnResidency(this.allProfiles ?? []);
          }

          this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
          if (this.isAnesthesistePage()) {
            this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeAnesth);
          } else {
            this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeInf);
          }

          if (this.vacation?.individuals?.length > 0 && this.resultProfiles2?.length > 0) {
            const selectedIds = this.vacation.individuals.map((p: Profile) => p._id);
            this.resultProfiles2.forEach((profile: Profile) => {
              if (selectedIds.includes(profile._id)) {
                profile.checked = true;
              }
              if (this.vacation?.individuals.includes(profile._id)) {
                profile.checked = true;
              }
            });
          }
          this.loadingProfiles = false;
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getAvailableAndOutOfRoomProfiles() {
    const dateValue = this.formGroup?.get('day')?.value;
    const date = new Date(dateValue);
    date.setHours(0, 0, 0, 0);
    const utcMidnight = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
    const pos = await this.userService.getAccessOptionsPositionsByPositions(
      this.accessOptions?.positionsInPopUp ?? [''],
      true
    );

    this.subscriptionManager
      .createRequest(
        this.profileService.getAvailableAndOutOfRoomProfiles(
          this.hospital?._id ?? '',
          utcMidnight.toISOString(),
          pos.map((po: any) => po.name) ?? [''],
          this.residencies?.map((res: any) => res.label),
          this.seniorities?.map((sen: any) => sen.label)
        ),
        'getAvailableAndOutOfRoomProfiles',
        this.instanceId
      )
      .subscribe({
        next: (res: any) => {
          this.availableOutOfRoomProfiles = [];
          this.availableOutOfRoomProfiles = res;
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getAnesthSpecialties(hospitalId: any) {
    let blocSpecialties: any[] = [];
    let consultationSpecialties: any[] = [];

    this.subscriptionManager
      .createRequest(
        this.wishesService.getWishesByProfileAndTypeFromHospital(
          this.currentUser.profile?._id ?? '',
          'bloc',
          hospitalId
        ),
        'getWishesByProfileAndTypeFromHospital',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          result = result.filter(
            (s: any) =>
              s.specialty.name !== 'DEFAULT_' &&
              s.specialty.name !== 'Bariatrique' &&
              !s.specialty.isEmergency &&
              s.specialty.name !== 'Anesthésie-réanimation' &&
              !s.specialty.name.match(/extra/i)
          );

          blocSpecialties = result.map((obj: any) => obj.specialty);

          this.subscriptionManager
            .createRequest(
              this.wishesService.getWishesByProfileAndTypeFromHospital(
                this.currentUser.profile?._id ?? '',
                'consultation',
                hospitalId
              ),
              'getWishesByProfileAndTypeFromHospitalConsultation',
              this.instanceId
            )
            .subscribe({
              next: (result: any) => {
                result = result.filter(
                  (s: any) =>
                    s.specialty.name !== 'DEFAULT_' &&
                    s.specialty.name !== 'Bariatrique' &&
                    !s.specialty.isEmergency &&
                    s.specialty.name !== 'Anesthésie-réanimation' &&
                    !s.specialty.name.match(/extra/i)
                );

                consultationSpecialties = result.map((obj: any) => obj.specialty);
                this.anesthSpecialties = [...(blocSpecialties || []), ...(consultationSpecialties || [])].reduce(
                  (acc: any, curr: any) => {
                    if (!acc.some((item: any) => item._id === curr._id)) {
                      acc.push(curr);
                    }
                    return acc;
                  },
                  []
                );
                this.chosenSpecialty =
                  this.chosenSpecialties.length >= 1
                    ? this.chosenSpecialties[0]
                    : this.vacation?.informations?.specialty && this.vacation?.informations?.specialty?._id
                      ? this.vacation?.informations?.specialty?._id
                      : 'undefined';
              },

              error: (error: any) => {
                this.errorService.handleError(error);
              },
            });
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  // get profiles from specialty using new Route: /api/profiles/ratedBySpecialty/:position
  getProfilesBySpecialty(position: string, hospitalId: any) {
    let vacationDate: any;
    if (this.formGroup && this.formGroup?.get('day')?.value) {
      vacationDate = this.formGroup?.get('day')?.value;
    } else {
      vacationDate = new Date();
      vacationDate.setDate(vacationDate.getDate() + 1);
    }
    const vacationFormattedDate = moment(vacationDate).format('YYYY-MM-DD');

    this.subscriptionManager
      .createRequest(
        this.profileService.getProfilesBySpecialtyInDateFromHospital(position, hospitalId, vacationFormattedDate),
        'getProfilesBySpecialtyInDateFromHospital',
        this.instanceId
      )
      .subscribe({
        next: (res: any) => {
          this.specialtyProfiles = JSON.parse(JSON.stringify(res));
          this.chosenSpecialty =
            this.chosenSpecialties.length >= 1
              ? this.chosenSpecialties[0]
              : this.vacation?.informations?.specialty && this.vacation?.informations?.specialty?._id
                ? this.vacation?.informations?.specialty?._id
                : 'undefined';
          this.resultProfiles2 = JSON.parse(JSON.stringify(res));
          this.originalResultProfiles2 = JSON.parse(JSON.stringify(this.resultProfiles2));
          if (this.isAnesthesistePage()) {
            this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeAnesth);
          } else {
            this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeInf);
          }
          if (this.vacation?.individuals?.length > 0 && this.resultProfiles2?.length > 0) {
            const selectedIds = this.vacation.individuals.map((p: Profile) => p._id);
            this.resultProfiles2.forEach((profile: Profile) => {
              if (selectedIds.includes(profile._id)) {
                profile.checked = true;
              }
              if (this.vacation?.individuals.includes(profile._id)) {
                profile.checked = true;
              }
            });
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
    if (position === 'anesth') {
      this.subscriptionManager
        .createRequest(
          this.profileService.getProfilesBySpecialtyInDateFromHospital('Iade', hospitalId, vacationFormattedDate),
          'getProfilesBySpecialtyInDateFromHospitalIade',
          this.instanceId
        )
        .subscribe({
          next: (res: any) => {
            this.specialtyProfiles2 = JSON.parse(JSON.stringify(res));
            this.resultProfiles3 = JSON.parse(JSON.stringify(res));
            if (this.isAnesthesistePage()) {
              this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeAnesth);
            } else {
              this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeInf);
            }
            if (this.vacation?.individuals?.length > 0 && this.resultProfiles2?.length > 0) {
              const selectedIds = this.vacation.individuals.map((p: Profile) => p._id);
              this.resultProfiles2.forEach((profile: Profile) => {
                if (selectedIds.includes(profile._id)) {
                  profile.checked = true;
                }
              });
            }
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }
  }

  getSelectedIDS(profiles: any[]): string[] {
    const selectProfiles = profiles.filter((el: any) => el.checked);
    return selectProfiles.map((el: any) => el._id);
  }

  onValueChanges(): void {
    if (this.formGroup?.get('position')) {
      this.subscriptionManager
        .createRequest(this.formGroup.get('position')!.valueChanges, 'positionValueChanges', this.instanceId)
        .subscribe({
          next: async (val: any) => {
            this.selectedReasonMap = null;
            this.chosenPositions = val;
            this.formationsGroupOfPosition = await this.userService.getFormationsGroupOfProfile({
              position: val,
            });
            this.showSeniority = this.formationsGroupOfPosition?.isUsingSeniorities ?? false;
            this.haveSeniority =
              !this.formationsGroupOfPosition?.isUsingSeniorities ||
              (this.formGroup?.value?.seniority && this.formGroup?.value?.seniority?.length > 0);
            this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
            this.updateProfilesOnCompetence(this.chosenSpecialty, this.isNurses ? this.typeInf : this.typeAnesth);
            this.formGroup?.get('selectAllProfiles')?.setValue(false);
            this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);

            if (this.vacation?.individuals?.length > 0 && this.resultProfiles2?.length > 0) {
              const selectedIds = this.vacation.individuals.map((p: Profile) => p._id);
              this.resultProfiles2.forEach((profile: Profile) => {
                if (selectedIds.includes(profile._id)) {
                  profile.checked = true;
                }
              });
            }
            this.getIsTimeCodeDisabled();
            if (this.data.preselectedReasonMap) {
              this.selectedReasonMap = this.data.preselectedReasonMap;
            }
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    if (this.formGroup?.get('residency')) {
      this.subscriptionManager
        .createRequest(this.formGroup?.get('residency')!.valueChanges, 'residencyValueChanges', this.instanceId)
        .subscribe({
          next: (val: any) => {
            this.selectedReasonMap = null;
            this.chosenResedencies = val;
            this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
            this.updateProfilesOnCompetence(this.chosenSpecialty, this.isNurses ? this.typeInf : this.typeAnesth);
            this.formGroup?.get('selectAllProfiles')?.setValue(false);
            this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);

            if (this.vacation?.individuals?.length > 0 && this.resultProfiles2?.length > 0) {
              const selectedIds = this.vacation.individuals.map((p: Profile) => p._id);
              this.resultProfiles2.forEach((profile: Profile) => {
                if (selectedIds.includes(profile._id)) {
                  profile.checked = true;
                }
              });
            }
            this.getIsTimeCodeDisabled();
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    if (this.isAnesthesistePage() && this.formGroup?.get('seniority')) {
      this.subscriptionManager
        .createRequest(this.formGroup.get('seniority')!.valueChanges, 'seniorityValueChanges', this.instanceId)
        .subscribe({
          next: async (val: any) => {
            this.selectedReasonMap = null;
            this.haveSeniority = !this.formationsGroupOfPosition?.isUsingSeniorities || val.length > 0;
            this.chosenSeniorities = val;
            this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
            this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeAnesth);
            this.formGroup?.get('selectAllProfiles')?.setValue(false);
            this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);

            if (this.vacation?.individuals?.length > 0 && this.resultProfiles2?.length > 0) {
              const selectedIds = this.vacation.individuals.map((p: Profile) => p._id);
              this.resultProfiles2.forEach((profile: Profile) => {
                if (selectedIds.includes(profile._id)) {
                  profile.checked = true;
                }
                if (this.vacation?.individuals.includes(profile._id)) {
                  profile.checked = true;
                }
              });
            }
            this.getIsTimeCodeDisabled();
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    if (this.isNurses) {
      if (this.formGroup?.get('typeInf')) {
        this.subscriptionManager
          .createRequest(this.formGroup.get('typeInf')!.valueChanges, 'typeInfValueChanges', this.instanceId)
          .subscribe({
            next: (val: any) => {
              this.formGroup?.get('selectAllProfiles')?.setValue(false);
              this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);
              this.typeInf = val;
              this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
              this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeInf);
            },

            error: (error: any) => {
              this.errorService.handleError(error);
            },
          });
      }

      if (this.formGroup?.get('competenceFilter')) {
        this.subscriptionManager
          .createRequest(
            this.formGroup.get('competenceFilter')!.valueChanges,
            'competenceFilterValueChanges',
            this.instanceId
          )
          .subscribe({
            next: (val: any) => {
              this.formGroup?.get('selectAllProfiles')?.setValue(false);
              this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);
              if (val) {
                this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
                this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeInf);
              }
              if (this.vacation?.individuals?.length > 0 && this.resultProfiles2?.length > 0) {
                const selectedIds = this.vacation.individuals.map((p: Profile) => p._id);
                this.resultProfiles2.forEach((profile: Profile) => {
                  if (selectedIds.includes(profile._id)) {
                    profile.checked = true;
                  }
                  if (this.vacation?.individuals.includes(profile._id)) {
                    profile.checked = true;
                  }
                });
              }
            },

            error: (error: any) => {
              this.errorService.handleError(error);
            },
          });
      }
    }

    if (this.isAnesthesistePage() && this.showSeniority) {
      if (this.formGroup?.get('typeAnesth')) {
        this.subscriptionManager
          .createRequest(this.formGroup.get('typeAnesth')!.valueChanges, 'typeAnesthValueChanges', this.instanceId)
          .subscribe({
            next: (val: any) => {
              this.typeAnesth = val;
              this.formGroup?.get('selectAllProfiles')?.setValue(false);
              this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);
              this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeAnesth);
            },

            error: (error: any) => {
              this.errorService.handleError(error);
            },
          });
      }

      if (this.showSeniority && this.formGroup?.get('competenceFilter')) {
        this.subscriptionManager
          .createRequest(
            this.formGroup.get('competenceFilter')!.valueChanges,
            'competenceFilterValueChanges',
            this.instanceId
          )
          .subscribe({
            next: (val: any) => {
              this.formGroup?.get('selectAllProfiles')?.setValue(false);
              this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);
              if (val) {
                this.updateProfilesOnCompetence(this.chosenSpecialty, this.typeAnesth);
              }
            },

            error: (error: any) => {
              this.errorService.handleError(error);
            },
          });
      }
    }

    if (this.formGroup?.get('competence')) {
      this.subscriptionManager
        .createRequest(this.formGroup.get('competence')!.valueChanges, 'competenceValueChanges', this.instanceId)
        .subscribe({
          next: (val: any) => {
            this.formGroup?.get('selectAllProfiles')?.setValue(false);
            this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);
            this.chosenSpecialty = val;
            this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
            if (this.isNurses) {
              this.isNursesNeeded(val);
              this.updateProfilesOnCompetence(val, this.typeInf);
            } else {
              this.isAnesthNeeded(val);
              this.updateProfilesOnCompetence(val, this.typeAnesth);
            }
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    if (this.formGroup?.get('competences')) {
      this.subscriptionManager
        .createRequest(this.formGroup.get('competences')!.valueChanges, 'competencesValueChanges', this.instanceId)
        .subscribe({
          next: (val: any) => {
            this.formGroup?.get('selectAllProfiles')?.setValue(false);
            this.formGroup?.get('selectOutOfRoomProfiles')?.setValue(false);
            this.chosenSpecialty = val;

            this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
            if (this.isNurses) {
              this.isNursesNeeded(val);
              this.updateProfilesOnCompetence(val, this.typeInf);
            } else {
              this.isAnesthNeeded(val);
              this.updateProfilesOnCompetence(val, this.typeAnesth);
            }
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    if (this.formGroup?.get('availability')) {
      this.subscriptionManager
        .createRequest(this.formGroup.get('availability')!.valueChanges, 'availabilityValueChanges', this.instanceId)
        .subscribe({
          next: (val: any) => {
            this.onAvailabilityChange(val);
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    if (this.formGroup?.get('selectAllProfiles')) {
      this.subscriptionManager
        .createRequest(
          this.formGroup.get('selectAllProfiles')!.valueChanges,
          'selectAllProfilesValueChanges',
          this.instanceId
        )
        .subscribe({
          next: (val: any) => {
            if (val) {
              this.selectAll(this.competenceFilter ? this.resultProfiles2 : this.resultProfiles, true);
            } else {
              this.selectAll(this.competenceFilter ? this.resultProfiles2 : this.resultProfiles, false);
            }
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }

    if (this.formGroup?.get('selectOutOfRoomProfiles')) {
      this.subscriptionManager
        .createRequest(
          this.formGroup.get('selectOutOfRoomProfiles')!.valueChanges,
          'selectOutOfRoomProfilesValueChanges',
          this.instanceId
        )
        .subscribe({
          next: (val: any) => {
            if (val) {
              this.resultProfiles2 = this.resultProfiles2.filter((profile: any) => profile.isOutOfRoom);
              this.originalResultProfiles2 = JSON.parse(JSON.stringify(this.resultProfiles2));
            } else {
              this.updateProfiles(this.chosenResedencies, this.chosenSeniorities);
              this.resultProfiles2 = this.resultProfiles;
              this.originalResultProfiles2 = this.resultProfiles;
            }
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }
  }

  changeSelectAllState(): void {
    const allChecked = this.resultProfiles2.every((profile: any) => profile.checked || !profile.haveUser);
    this.formGroup?.get('selectAllProfiles')?.setValue(allChecked, { emitEvent: false });
  }

  makeForm(positions: string[], residency: string[]) {
    if (!this.isMultiHospitals) {
      this.formGroup = this.formBuilder.group({
        period: null,
        position: [{ value: positions, disabled: this.vacation ? true : false }, [Validators.required]],
        residency: [
          { value: residency, disabled: this.vacation ? true : false },
          [Validators.required, Validators.minLength(1)],
        ],
        needs: [{ value: this.vacation?.needs ?? 1, disabled: this.vacation ? true : false }, [Validators.required]],
        day: [{ value: this.day, disabled: this.vacation ? true : false }, [Validators.required]],
        targeted: [
          this.vacation && this.vacation.individuals && this.vacation.individuals.length > 0 ? true : false,
          [Validators.required],
        ],
        competenceFilter: [
          (this.data.specialty && this.data.role) ||
          (this.vacation?.informations?.roleName && this.vacation?.informations?.specialty)
            ? true
            : false,
          [Validators.required],
        ],
        typeInf: [
          { value: this.vacation?.informations?.roleName ?? 'undefined', disabled: this.vacation ? true : false },
          [Validators.required],
        ],
        competence: [
          {
            value: this.chosenSpecialty,
            disabled: this.vacation && this.data?.specialties?.length === 1 ? true : false,
          },
          Validators.required,
        ],
        competences: [
          {
            value: this.chosenSpecialties,
            disabled: true,
          },
        ],
        selectAllProfiles: [false],
        selectOutOfRoomProfiles: [false],
        hospitals: [
          { value: this.selectedHospitalsId[0], disabled: this.vacation ? true : false },
          [Validators.required],
        ],
        startTime: [
          this.vacation?.informations?.startTime ??
            (this.hospitals[0].startTime
              ? moment.utc(this.hospitals[0].startTime).format('HH:mm')
              : HOSPITAL_START_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        endTime: [
          this.vacation?.informations?.endTime ??
            (this.hospitals[0].endTime ? moment.utc(this.hospitals[0].endTime).format('HH:mm') : HOSPITAL_END_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        motif: [this.selectedMotif],
        availability: [this.availability, [Validators.required]],
      });
    } else {
      this.formGroup = this.formBuilder.group({
        position: [{ value: positions, disabled: this.vacation ? true : false }, [Validators.required]],
        residency: [
          { value: residency, disabled: this.vacation ? true : false },
          [Validators.required, Validators.minLength(1)],
        ],
        needs: [this.vacation?.needs ?? 1, [Validators.required]],
        day: [{ value: this.day, disabled: this.vacation ? true : false }, [Validators.required]],
        targeted: [
          this.vacation && this.vacation.individuals && this.vacation.individuals.length > 0 ? true : false,
          [Validators.required],
        ],
        competenceFilter: [this.data.specialty && this.data.role ? true : false, [Validators.required]],
        typeInf: [
          { value: this.vacation?.informations?.roleName ?? 'undefined', disabled: this.vacation ? true : false },
          [Validators.required],
        ],
        competence: [
          {
            value: this.chosenSpecialty,
            disabled: this.vacation && this.data?.specialties?.length === 1 ? true : false,
          },
          Validators.required,
        ],
        competences: [
          {
            value: this.chosenSpecialties,
            disabled: true,
          },
        ],
        selectAllProfiles: [false],
        selectOutOfRoomProfiles: [false],
        hospitals: [
          { value: this.hospitals[0], disabled: this.vacation ? (this.vacation ? true : false) : false },
          [Validators.required],
        ],
        startTime: [
          this.vacation?.informations?.startTime ??
            (this.hospitals[0].startTime
              ? moment.utc(this.hospitals[0].startTime).format('HH:mm')
              : HOSPITAL_START_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        endTime: [
          this.vacation?.informations?.endTime ??
            (this.hospitals[0].endTime ? moment.utc(this.hospitals[0].endTime).format('HH:mm') : HOSPITAL_END_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        motif: [this.selectedMotif],
        availability: [this.availability, [Validators.required]],
      });
    }
  }

  makeAnestForm(positions: any, residency: string[]) {
    if (!this.isMultiHospitals) {
      this.formGroup = this.formBuilder.group({
        position: [{ value: positions.name, disabled: this.vacation ? true : false }, [Validators.required]],
        residency: [
          { value: residency, disabled: this.vacation ? true : false },
          [Validators.required, Validators.minLength(1)],
        ],
        seniority: [
          {
            value: this.accessOptions?.seniority,
            disabled: this.vacation ? true : false,
          },
        ],
        needs: [this.vacation?.needs ?? 1, [Validators.required]],
        day: [{ value: this.day, disabled: this.vacation ? true : false }, [Validators.required]],
        targeted: [
          this.vacation && this.vacation.individuals && this.vacation.individuals.length > 0 ? true : false,
          [Validators.required],
        ],
        competenceFilter: [!!(this.data.specialty && this.data.role), [Validators.required]],
        typeAnesth: [
          { value: this.vacation?.informations?.roleName ?? 'undefined', disabled: this.vacation ? true : false },
          [Validators.required],
        ],
        competence: [
          {
            value: this.chosenSpecialty,
            disabled: this.vacation && this.data?.specialties?.length === 1 ? true : false,
          },
          Validators.required,
        ],
        competences: [
          {
            value: this.chosenSpecialties,
            disabled: true,
          },
        ],
        selectAllProfiles: [false],
        selectOutOfRoomProfiles: [false],
        hospitals: [{ value: this.principalHospitalId, disabled: this.vacation ? true : false }, [Validators.required]],
        startTime: [
          this.vacation?.informations?.startTime ??
            (this.hospitals[0].startTime
              ? moment.utc(this.hospitals[0].startTime).format('HH:mm')
              : HOSPITAL_START_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        endTime: [
          this.vacation?.informations?.endTime ??
            (this.hospitals[0].endTime ? moment.utc(this.hospitals[0].endTime).format('HH:mm') : HOSPITAL_END_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        motif: [this.selectedMotif],
        availability: [this.availability, [Validators.required]],
      });
    } else {
      this.formGroup = this.formBuilder.group({
        position: [{ value: positions.name, disabled: this.vacation ? true : false }, [Validators.required]],
        residency: [
          { value: residency, disabled: this.vacation ? true : false },
          [Validators.required, Validators.minLength(1)],
        ],
        seniority: [
          {
            value: this.accessOptions?.seniority,
            disabled: this.vacation ? true : false,
          },
          [Validators.required],
        ],
        needs: [this.vacation?.needs ?? 1, [Validators.required]],
        day: [{ value: this.day, disabled: this.vacation ? true : false }, [Validators.required]],
        targeted: [
          this.vacation && this.vacation.individuals && this.vacation.individuals.length > 0 ? true : false,
          [Validators.required],
        ],
        competenceFilter: [!!(this.data.specialty && this.data.role), [Validators.required]],
        typeAnesth: [
          { value: this.vacation?.informations?.roleName ?? 'undefined', disabled: this.vacation ? true : false },
          [Validators.required],
        ],
        competence: [
          {
            value: this.chosenSpecialty,
            disabled: !!(this.vacation && this.data?.specialties?.length === 1),
          },
          Validators.required,
        ],
        competences: [
          {
            value: this.chosenSpecialties,
            disabled: true,
          },
          Validators.required,
        ],
        selectAllProfiles: [false],
        selectOutOfRoomProfiles: [false],
        hospitals: [
          { value: this.hospitals[0], disabled: this.vacation ? (this.vacation ? true : false) : false },
          [Validators.required],
        ],
        startTime: [
          this.vacation?.informations?.startTime ??
            (this.hospitals[0].startTime
              ? moment.utc(this.hospitals[0].startTime).format('HH:mm')
              : HOSPITAL_START_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        endTime: [
          this.vacation?.informations?.endTime ??
            (this.hospitals[0].endTime ? moment.utc(this.hospitals[0].endTime).format('HH:mm') : HOSPITAL_END_TIME),
          [Validators.required, Validators.pattern(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        ],
        motif: [this.selectedMotif],
        availability: [this.availability, [Validators.required]],
      });
    }
  }

  setCompetenceFilter(value: boolean) {
    this.formGroup?.get('competenceFilter')?.patchValue(value);
  }

  getResidencyFromForm(): string {
    const residencies = this.formGroup?.value?.residency;
    if (residencies?.length === 1) {
      return residencies[0];
    } else {
      return 'Titulaire et Vacataire';
    }
  }

  getPositionFromForm(): string | undefined {
    const position = this.formGroup?.controls?.['position']?.value;
    if (this.isNurses) {
      return undefined;
    }

    if (position) {
      return String(position).toLowerCase() === 'iade' ? 'IADE' : position;
    }

    return position;
  }

  getFormationsFromForm(): string[] | undefined {
    if (this.isNurses) {
      let selectedFormations = this.formGroup?.controls?.['position']?.value;
      if (!Array.isArray(selectedFormations)) {
        selectedFormations = [selectedFormations];
      }
      if (this.isAnesthesistePage()) {
        return selectedFormations;
      }
      return selectedFormations?.map((form: any) => {
        const formation = this.data?.position?.find((f: any) => f.name === form && f.hospital === this.hospital?._id);
        return formation?._id;
      });
    }
    return undefined;
  }

  setVacation() {
    const formValue = this.formGroup?.getRawValue();
    const rawCompetence = formValue?.competence;
    const chosenSpecialty =
      rawCompetence && rawCompetence !== 'undefined' ? rawCompetence : formValue?.competences?.[0];
    let roleId: any;

    if (this.competenceFilter && chosenSpecialty && chosenSpecialty !== 'undefined') {
      this.roles.forEach((role: any) => {
        if (role.name === this.typeInf || this.typeInf === role._id) {
          roleId = role._id;
        }
      });
    }

    if (!this.showSeniority) {
      formValue.seniority = null;
    }

    const position = this.vacation?.position?.name ?? this.vacation?.position ?? this.getPositionFromForm();

    const vacation = {
      hospital: this.isMultiHospitals ? formValue.hospitals._id : this.selectedHospitalsId[0],
      needs: formValue.needs ?? 1,
      voluntaries: [],
      chosenOnes: [],
      seniority: formValue.seniority,
      dateofcreation: moment(this.vacation ? formValue.day : this.day).format('YYYY-MM-DD'),
      date: moment(this.formGroup?.get('day')?.value).format('YYYY-MM-DD'),
      position: typeof position === 'string' ? (position.toLowerCase() === 'iade' ? 'IADE' : position) : position,
      formations: this.vacation?.formations ?? this.getFormationsFromForm(),
      residency: this.vacation?.residency ?? this.getResidencyFromForm(),
      informations: {
        specialty:
          this.competenceFilter && chosenSpecialty && chosenSpecialty !== 'undefined' ? [chosenSpecialty] : undefined,
        type: this.isNurses ? roleId : this.typeAnesth === 'undefined' ? undefined : this.typeAnesth,
        startTime: formValue.startTime,
        endTime: formValue.endTime,
        code: this.selectedReasonMap && this.selectedReasonMap.code ? this.selectedReasonMap.code : undefined,
      },
      state: 'OPENED',
      individuals: formValue.targeted ? this.getSelectedIDS(this.resultProfiles2) : null,
      reasonMap: this.selectedReasonMap?._id ?? null,
      motif: this.selectedMotif?._id ?? null,
    };

    return {
      vacation,
      message: {
        text: `(${this.hospitalNames.vacationsName} ${this.hospitalNames.vacationsNameGenreMasculin ? 'supprimé' : 'supprimée'})`,
      },
    };
  }

  save() {
    posthog.capture('Complete_Add_Vacation/Mission_Form');
    this.isSpinning = true;
    this.isDisabled = true;
    this.isSending = true;
    const vacation = this.setVacation();

    this.subscriptionManager
      .createRequest(this.vacationService.addVacation(vacation), 'addVacation', this.instanceId)
      .subscribe({
        next: () => {
          this.isSpinning = false;
          this.isDisabled = false;

          this.isSending = false;
          this.dialogRef.close(true);
          this.utilisService.displaySuccessToast();
        },
        error: (error: any) => this.errorService.handleError(error),
      });
  }

  // getSpecialties : to get all specialties from specialtyService
  getSpecialties(hospitalId: any) {
    return new Promise<Specialty[]>((resolve: any, reject: any) => {
      this.subscriptionManager
        .createRequest(
          this.specialtyService.getAllSpecialtiesFromHospital(false, hospitalId),
          'getAllSpecialtiesFromHospital',
          this.instanceId
        )
        .subscribe({
          next: (specialties: any) => {
            if (specialties && specialties.length > 0) {
              specialties = specialties.filter((s: any) => s.name !== 'DEFAULT_');
              this.chosenSpecialty =
                this.chosenSpecialties.length >= 1
                  ? this.chosenSpecialties[0]
                  : this.vacation?.informations?.specialty && this.vacation?.informations?.specialty?._id
                    ? this.vacation?.informations?.specialty?._id
                    : 'undefined';
              resolve(specialties);
            }
          },
          error: (error: any) => {
            this.errorService.handleError(error);
            reject(error);
          },
        });
    });
  }

  // to sort profiles in ascending order
  sortProfiles(profiles: Profile[] | undefined) {
    if (!profiles) {
      return;
    }

    profiles = profiles.sort((a: any, b: any) => {
      if (a.firstName?.localeCompare(b.firstName) !== 0) {
        //if 2 firstNames don't have the same sort
        return a.firstName?.toLowerCase().localeCompare(b.firstName?.toLowerCase());
      } else {
        // else compare by lastname
        return a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase());
      }
    });
  }

  /**
   * Update the filters on 'allProfiles' when there is any change on residencies,
   * seniority or nurses positions
   * @param residency chosen residency
   * @param seniority chosen seniority
   * @returns
   */
  updateProfiles(residency: string[], seniority: string[]) {
    if (residency.length == 0) {
      this.resultProfiles = [];
      return;
    }
    if (!this.chosenPositions?.length && !this.chosenPositions?.name) {
      this.resultProfiles = [];
      return;
    }
    if (this.isAnesthesistePage() && !seniority.length) {
      this.resultProfiles = [];
      return;
    }

    let positions: string[];
    if (Array.isArray(this.chosenPositions)) {
      positions = this.chosenPositions.map((pos: any) => String(pos).toLowerCase());
    } else {
      positions = [((this.chosenPositions?.name ?? this.chosenPositions) as string).toLowerCase()];
    }
    if (this.availability === 'AVAILABLE') {
      this.resultProfiles =
        this.allProfiles?.filter((profile: any) => {
          return (
            residency.includes(String(profile.residency)) && positions.includes(String(profile.position?.toLowerCase()))
          );
        }) ?? [];
    } else {
      this.resultProfiles =
        this.availableOutOfRoomProfiles?.filter((profile: any) => {
          return (
            residency.includes(String(profile.residency)) && positions.includes(String(profile.position?.toLowerCase()))
          );
        }) ?? [];
    }

    if (this.isAnesthesistePage()) {
      if (positions.length === 1 && positions[0] === 'anesthésiste') {
        this.resultProfiles = this.resultProfiles?.filter((profile: any) => {
          return seniority.includes(String(profile.seniority));
        });
      }
    }

    if (this.vacation) {
      if (this.vacation.voluntaries) {
        const voluntariesIds = this.vacation.voluntaries.map((profile: any) => profile.profile._id);
        this.resultProfiles = this.resultProfiles?.filter((profile: any) => !voluntariesIds.includes(profile._id));
      }
      if (this.vacation.unavailables) {
        const unavailablesIds = this.vacation.unavailables.map((profile: any) => profile.profile._id);
        this.resultProfiles = this.resultProfiles?.filter((profile: any) => !unavailablesIds.includes(profile._id));
      }
    }
    this.sortProfiles(this.resultProfiles);
  }

  filterProfilesOnSpecialty(position: string, type: string, spec: string) {
    // get the selected role
    let roleId: any;
    this.roles.forEach((role: any) => {
      if (role.name === type) {
        roleId = role._id;
      }
    });

    let temp = [];
    if (position === 'IADE') {
      if (this.specialtyProfiles2) {
        temp = this.specialtyProfiles2.filter((specialty: any) => specialty.specialty._id === spec);
      } else {
        temp = [];
      }
    } else {
      if (this.specialtyProfiles) {
        temp = this.specialtyProfiles.filter((profile: any) => {
          return profile.specialty && profile.specialty._id == spec;
        });
      } else {
        temp = [];
      }
    }

    if (temp.length > 0) {
      Object.keys(temp[0]).forEach((roleIdList: any) => {
        if (roleId === roleIdList || (position === 'IADE' && roleIdList !== 'specialty')) {
          const temp2 = JSON.parse(JSON.stringify(temp[0][roleIdList]));
          const profilesIds = this.resultProfiles.map((profile: any) => profile._id);
          this.resultProfiles2 = temp2.filter((profile: any) => profilesIds.includes(profile._id));
          this.originalResultProfiles2 = JSON.parse(JSON.stringify(this.resultProfiles2));
        }
      });
    } else {
      this.resultProfiles2 = [];
      this.originalResultProfiles2 = [];
    }
  }

  /**
   * Update the profiles selected based on the competence
   * @param spec the chosen specialty
   * @param type the type of anesthestist or nurse
   * @returns
   */
  updateProfilesOnCompetence(spec: string, type: string) {
    // spec === "undefined" only if we don't filter
    if (spec === 'undefined') {
      this.resultProfiles2 = JSON.parse(JSON.stringify(this.resultProfiles));
      this.originalResultProfiles2 = JSON.parse(JSON.stringify(this.resultProfiles));
      return;
    }

    const position = this.formGroup?.get('position')?.value;
    if (this.isAnesthesistePage()) {
      if (
        ((Array.isArray(this.chosenPositions) && this.chosenPositions.includes('Anesthésiste')) ||
          this.chosenPositions?.name === 'Anesthésiste' ||
          this.chosenPositions === 'Anesthésiste') &&
        this.chosenSeniorities.length === 0
      ) {
        this.resultProfiles2 = [];
        this.originalResultProfiles2 = [];
        return;
      }

      let temp = [];
      if (position === 'IADE') {
        this.filterProfilesOnSpecialty(position, type, spec);
      } else {
        if (this.specialtyProfiles) {
          temp = this.specialtyProfiles.filter((specialty: any) => specialty.specialty._id === spec);
        } else {
          temp = [];
        }
        let temp2 = [];
        if (temp.length > 0) {
          if (type == this.hospitalNames.blocName) {
            temp2 = temp.map((obj: any) => obj.bloc)[0];
          } else {
            temp2 = temp.map((obj: any) => obj.consultation)[0];
          }
        }

        const profilesIds = this.resultProfiles.map((profile: any) => profile._id);
        this.resultProfiles2 = temp2.filter((profile: any) => profilesIds.includes(profile._id));
        this.originalResultProfiles2 = JSON.parse(JSON.stringify(this.resultProfiles2));
      }
    } else {
      this.filterProfilesOnSpecialty('Infirmiere', type, spec);
    }
  }

  isNursesNeeded(spec: any) {
    const specialty = this.specialties?.find((obj: any) => obj._id == spec);
    this.typeInfOptions = [];
    if (specialty) {
      specialty.needs.forEach((role: any) => {
        if (role.role.name !== 'IADE') {
          this.roles.push(role.role);

          this.typeInfOptions.push({
            label: role.role.name,
            value: role.role.name,
          });

          //Avoid selected role to be based on previous specialty
          if (this.data.role) {
            const foundRole = this.typeInfOptions?.find(
              (role: any) => String(role.value) === String(this.data.role.name)
            );
            this.formGroup?.get('typeInf')?.setValue(foundRole ? foundRole.value : this.typeInfOptions[0].value);
          } else {
            this.formGroup?.get('typeInf')?.setValue(this.typeInfOptions[0].value);
          }
        }
      });
    } else if (this.vacation?.informations?.rolename) {
      this.typeInfOptions.push({
        label: this.vacation?.informations?.rolename,
        value: this.vacation?.informations?.rolename,
      });
      this.formGroup?.get('typeInf')?.setValue(this.typeInfOptions[0].value);
    } else {
      this.typeInfOptions.push({
        label: 'Tous les rôles',
        value: 'undefined',
      });
      this.formGroup?.get('typeInf')?.setValue(this.typeInfOptions[0].value);
    }
  }

  isAnesthNeeded(spec: any) {
    if (this.anesthSpecialties) {
      const specialty = this.anesthSpecialties?.find((obj: any) => obj._id == spec);
      if (specialty) {
        this.typeAnesthOptions = [];
        if (specialty.type.length <= 0) {
          this.showRole = false;
          return;
        }
        if (specialty.type.length >= 2) {
          this.showRole = true;
          if ((this.formationsGroupOfPosition?.workScopes?.length ?? 0) > 0) {
            if (this.formationsGroupOfPosition?.workScopes?.includes('bloc')) {
              this.typeAnesthOptions.push({
                label: this.hospitalNames.blocName,
                value: 'Bloc',
              });
            }
            if (this.formationsGroupOfPosition?.workScopes?.includes('consultation')) {
              this.typeAnesthOptions.push({
                label: this.hospitalNames.consultationName,
                value: 'Consultation',
              });
            }
            this.formGroup?.get('typeAnesth')?.setValue(this.hospitalNames.blocName);
          } else {
            this.showRole = false;
          }
          return;
        }
        if (specialty.type.includes('bloc') && this.formationsGroupOfPosition?.workScopes?.includes('bloc')) {
          this.showRole = true;
          this.formGroup?.get('typeAnesth')?.setValue(this.hospitalNames.blocName);

          this.typeAnesthOptions = [
            {
              label: this.hospitalNames.blocName,
              value: 'Bloc',
            },
          ];
          return;
        }
        if (
          specialty.type.includes('consultation') &&
          this.formationsGroupOfPosition?.workScopes?.includes('consultation')
        ) {
          this.showRole = true;
          this.formGroup?.get('typeAnesth')?.setValue('Consultation');
          this.typeAnesthOptions = [
            {
              label: this.hospitalNames.consultationName,
              value: 'Consultation',
            },
          ];
          return;
        }
      } else {
        this.typeAnesthOptions = [
          {
            label: 'Tous les rôles',
            value: 'undefined',
          },
        ];
        this.formGroup?.get('typeAnesth')?.setValue('undefined');
      }
    } else {
      this.typeAnesthOptions = [
        {
          label: 'Tous les rôles',
          value: 'undefined',
        },
      ];
      this.formGroup?.get('typeAnesth')?.setValue('undefined');
    }
  }

  selectAll(profiles: any[], check: boolean) {
    profiles.forEach((el: any) => {
      if (el.haveUser) {
        el.checked = check;
      }
    });
  }

  createNursesPosition() {
    if (this.isAnesthesistePage()) {
      this.nursesPosition = this.data.position
        .filter((formation: Formation) => {
          return (
            String(formation.hospital) ===
            (this.isMultiHospitals
              ? String(this.formGroup?.get('hospitals')?.value._id)
              : String(this.hospitals[0]?._id))
          );
        })
        .map((formation: Formation) => formation.name);
    } else {
      const formationsNames: string[] = this.data.position
        ?.filter(
          (formation: any) =>
            formation.hospital ===
            (this.isMultiHospitals ? this.formGroup?.get('hospitals')?.value._id : this.hospitals[0]?._id)
        )
        ?.map((formation: any) => formation.name);
      this.nursesPosition = formationsNames.map((name: string) => {
        return {
          label: name,
          value: name,
          isChecked: false,
        };
      });
    }
  }
}
